import {Component, Input, OnInit} from '@angular/core';

import { LanguageService } from '@shared/services/language.service';
import {NewNavigationService} from '@shared/services/new-navigation.service';
import { HELP_LINK } from '@src/app/utils/help-links';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
})
export class HelpComponent implements OnInit {

  @Input() isVisible = false;

  constructor(
    private newNavigationService: NewNavigationService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit(): void {
  }

  public onKnowledgeDatabase(): void {
    window.open(HELP_LINK[this.languageService.current], '_blank')!.focus();
  }

  public onRemoteHelp(): void {
    window.open('https://get.teamviewer.com/6rhbgm7', '_blank')!.focus();
  }

  public onClose(): void {
    this.newNavigationService.toMainPanel();
  }
}
